import type { UiStrings } from '../types'

const de: UiStrings = {
  brand: 'Holecard EX',
  docTitleSuffix: 'Prozess-Aufzeichnung',
  tagline: 'Seat · Holes · Board · Line aufzeichnen — teilbare Prozesskarte',
  metaDescription:
    'Holecard EX — mobilfreundliche Poker-Prozess-Aufzeichnung. Seat, Hole Cards, Board und Street-Aktionen in eine teilbare Karte.',
  stepsAria: 'Schritte',
  prev: 'Zurück',
  undo: 'Rückgängig',
  next: 'Weiter',
  nextSummary: 'Zusammenfassung anzeigen',
  privacyLink: 'Datenschutz- & Werberichtlinie',
  privacyTitle: 'Datenschutz- & Werberichtlinie',
  privacyHint: 'Entwurf für die AdSense-Prüfung. Vor dem produktiven Einsatz prüfen und aktualisieren.',
  privacyBack: 'Zurück zur App',
  privacyCollectTitle: '1. Welche Informationen wir erfassen',
  privacyCollectBody:
    'Holecard EX erstellt Hand-Review-Entwürfe derzeit nur im Browser. Kein Login erforderlich; Handdaten werden nicht an einen Server gesendet. Entwürfe können vorübergehend in sessionStorage dieses Tabs liegen (diese Richtlinie wird bei Änderungen aktualisiert).',
  privacyAdsTitle: '2. Cookies & Werbung',
  privacyAdsBody:
    'Drittanbieter-Werbenetzwerke wie Google AdSense können verwendet werden. Werbetreibende können Cookies oder Gerätekennungen für interessenbezogene Anzeigen nutzen. Personalisierte Anzeigen können Sie in Browser- oder Google-Anzeigeneinstellungen steuern.',
  privacyContactTitle: '3. Kontakt',
  privacyContactBody: 'Bei Fragen zur Richtlinie bitte ein GitHub-Issue zu holdcard-ex.com öffnen. Betreiber-E-Mail: TODO_OPERATOR_EMAIL in der Projektkonfiguration.',
  langAria: 'Sprache',
  langCompactAria: 'Sprache (kurz)',
  koPathLink: '한국어',
  koPathLinkAria: 'Koreanische Version (/ko)',
  enPathLink: 'English',
  enPathLinkAria: 'Englische Version (/)',
  setupTitle: 'Tisch',
  setupHint: 'Spieler · Stack · Blinds — dann Sitz → Hand → Linie',
  players: 'Spieler',
  playersUnit: (n) => `${n}-max`,
  sb: 'SB',
  bb: 'BB',
  ante: 'Ante (optional)',
  anteHint: 'Gleiche Einheit wie Blinds',
  effectiveStack: 'Effektiver Stack (BB, optional)',
  potBb: 'Pot (BB, optional)',
  metaOptionalHint: 'Ante / Eff-Stack / Pot leer lassen, um sie in Zusammenfassungen auszublenden',
  setupDetailsToggle: 'Spieler · Ante · Eff · Pot · Chips',
  setupBasicsHint: 'Standard (6-max · 100bb) ok — Weiter oder vorspringen',
  setupMetaSetChip: 'Ante · Eff · Pot gesetzt',
  stackUnit: 'Stack-Einheit',
  stackUnitBb: 'BB',
  stackUnitChips: 'Chips',
  stackChips: 'Stack (Chips)',
  stackBb: 'Stack (BB)',
  stackChipsUnit: 'Chips',
  positionTitle: 'Sitz',
  seatQuestion: 'Wo saßt du?',
  settingsBack: 'Zurück',
  settingsSegAria: 'Tisch-Einstellungen (Spieler · Blinds · Stack)',
  lineSeatEditAria: 'Sitz ändern',
  lineHoleEditAria: 'Hole Cards ändern',
  positionHint: (count, hint) => `${count}-max Sitze${hint ? ` · ${hint}` : ''}`,
  tableVizAria: (n) => `${n}-max Tischplätze`,
  tableVizHeroBadge: 'du',
  tableVizHeroSeatAria: (seat) => `${seat} (du)`,
  tableVizDealer: 'D',
  tableVizDealerTitle: 'Dealer-Button',
  tableVizTapHint: 'Tippe deinen Sitz am Tisch',
  tableVizListFallback: 'Sitze auflisten · Codes',
  tableVizBlindsAria: (v) => `Blinds ${v}`,
  tableVizPotPlaceholder: 'Pot',
  tableVizPotValue: (v) => `Pot ${v}`,
  tableVizPotAria: (v) => `Pot ${v}`,
  tableVizStackAria: (v) => `Stack ${v}`,
  tableVizEmptyMark: '—',
  tableVizEffHint: (v) => `Eff ${v}bb`,
  tableVizEffTitle: 'Effektiver Stack (tischweit, nicht pro Sitz)',
  tableVizStepDown: 'Verringern',
  tableVizStepUp: 'Erhöhen',
  tableVizEditDone: 'Fertig',
  tableVizInfoHint: 'Blinds, Pot oder Stack auf dem Tisch tippen zum Bearbeiten',
  seatAbbrevHint: 'Sitz-Kürzel. Tippen für den vollen Namen.',

  cardsTitle: 'Hand',
  cardsHint: 'Mit deinen Karten starten · Gegner über „Gegner hinzufügen“ · Slot · Farbe & Rang · keine Duplikate',
  heroHolesGuide: (seat) => `Wähle die zwei ${seat}-Hole-Cards.`,
  cardSlot1: 'Karte 1',
  cardSlot2: 'Karte 2',
  cardSlotSelect: 'Wählen',
  seatsLabel: 'Sitze',
  knownHolesOptional: 'Gegner-Hole-Cards sind optional (Showdown / Review — leer OK)',
  holesBySeat: 'Hole Cards · Sitz wählen',
  seatVillain: (pos) => `Villain ${pos}`,
  seatFilled: 'Gesetzt',
  holesModeHeroOnly: 'Nur meine',
  holesModeWithVillains: 'Gegner hinzufügen',
  holesModeAria: 'Hole-Card-Eingabemodus',
  villainNudgeToast: 'Gegnerhand bekannt? BB / CO usw. tippen',
  heroCardsDoneCta: 'Zur Linie',
  heroCardsAddVillainsCta: 'Gegner hinzufügen',
  suitPickerLabel: 'Farbe',
  rankPickerLabel: 'Rang',
  boardTitle: 'Board',
  boardHint: 'Wenn es so weit ist — für Preflop-only überspringen',
  flop: 'Flop',
  turn: 'Turn',
  river: 'River',
  flopSlot: (i) => `F${i}`,
  actionsTitle: 'Linie',
  actionsHint: 'Action-Linie streetweise — Fold / Check / Call / Bet / Raise / All-in',
  actorQuick: 'Schnell-Akteur',
  actor: 'Akteur',
  actorPlaceholder: 'Name eingeben',
  actorCustomToggle: 'Eigener Name',
  actorRequired: 'Akteur eingeben oder wählen',
  action: 'Aktion',
  sizeLabel: 'Größe',
  sizePlaceholder: 'z. B. 2.5bb',
  sizeRequired: 'Größe für Bet/Raise eingeben',
  sizeCustomToggle: 'Benutzerdefiniert',
  sizeOpenApprox: 'Open',
  sizePotApprox: 'Pot-Größe',
  sizeOverbetApprox: 'Overbet',
  sizeJamApprox: 'Short / Jam',
  sizeUnitBb: 'bb',
  sizeUnitPct: 'pot',
  snapHint: 'Rastet an Stops · ± ein Schritt',
  favoritesLabel: 'Favoriten',
  morePresets: 'Weitere Presets',
  presetsSizeLabel: 'Presets · Größe',
  potSizeHintUnset: 'Pot (BB) im Setup setzen, um Pot-Größe als bb zu sehen',
  clearOptional: 'Löschen',
  betRaiseHint: 'Bet: keine vorherige Aggression · Raise: gegen Bet/Raise',
  allinSizeHint: 'Optionale All-in-Größe',
  sizeActionHint: (potBit) => potBit ? `Bet=first · Raise=vs Bet · ${potBit}` : 'Bet=first · Raise=vs Bet',
  addAction: (street) => `${street}-Aktion hinzufügen`,
  updateAction: 'Aktualisieren',
  editAction: 'Bearbeiten',
  cancelEdit: 'Abbrechen',
  noStreetActions: (street) => `Noch keine ${street}-Aktionen.`,
  delete: 'Löschen',
  moveUp: 'Hoch',
  moveDown: 'Runter',
  allActionsHint: (n) => `${n} Aktionen gesamt · andere Street-Tabs prüfen`,
  heroChip: (pos) => pos,
  seatOrderHu: 'HU: BTN agiert als SB · Reihenfolge BTN/SB → BB',
  seatOrder: (order) => `Sitzreihenfolge: ${order}`,
  positionHintHuBtn: 'HU-Button (SB)',
  keepActorHint: 'Street-Tabs behalten den Akteur (nur Typ/Größe zurücksetzen)',
  potQuickPrompt: 'Schnell-Pot (BB) — tippen zum Setzen und Hinweis aktualisieren',
  potQuickClear: 'Pot löschen',
  quickLinesLabel: 'Schnell-Linien',
  quickLinesHint: 'Häufige Vorlagen — tippen zum Hinzufügen',
  macroOpenThenCall: 'Open dann Call',
  macroFoldToHero: (seat) => `Folds bis ${seat}`,
  macroCbet33: 'C-Bet ⅓ pot',
  quickLinesSwitchStreet: 'Street wechseln für Makros',
  macroOpenExists: 'Ein Open (Raise) ist bereits geloggt',
  macroAlreadyLogged: 'Open und Call sind bereits geloggt',
  macroFoldToHeroNone: (seat) => `Keine frühen Folds übrig (oder ${seat} handelt zuerst)`,
  macroFoldToHeroBlocked: 'Frühe Aktion schon geloggt — Folds manuell hinzufügen',
  boardCtaFlop: 'Flop-Karten hinzufügen',
  boardCtaTurn: 'Turn-Karte hinzufügen',
  boardCtaRiver: 'River-Karte hinzufügen',
  quickHand: 'Schnelle Hand',
  skipToCards: 'Zu Karten springen',
  jumpToActions: 'Zur Linie',
  skipBoardPreflop: 'Board überspringen — nur Preflop',
  boardSlotsToggle: 'Board-Karten hinzufügen',
  softStackAria: 'Hand bisher',
  softStackLine: 'Linie',
  softStackHoles: 'Hole Cards',
  softStackBoard: 'Board',
  streetTabWithCount: (street, n) => `${street} · ${n}`,
  actionIndexLabel: (n, street) => `Aktion ${n} · ${street}`,
  copyLinkTitle: 'Öffnet diese Hand erneut in der App',
  suitStickyHint: 'Farbe gehalten · Farbe tippen zum Ändern',
  suitStickyChip: (s) => `Aktuelle Farbe ${s}`,
  suitMruLabel: 'Zuletzt',
  summaryHint: 'Prozesskarte unten screenshotten oder Text kopieren/teilen',
  summaryHole: 'Hole Cards',
  summaryBoard: 'Board',
  summaryActions: 'Aktionen',
  timelineProcess: 'Ablauf',
  timelineBoard: (cards) => `Board ${cards}`,
  processMoreSummary: 'Mehr Ablauf',
  linePeekSummary: 'Linie bisher',
  takeawayLabel: 'Takeaway',
  takeawayPlaceholder: 'Nur Seat + Line — z. B. BTN raise, BB call, Flop check',
  takeawayHint: 'Eine Prozesszeile — nur Seat + Line',
  takeawayNudge: 'Prozesszeile (optional)\u00a0· Sitz\u00a0· Linie',
  takeawayInLinkFact: 'Die Prozesszeile ist im Link',
  shareSecondarySummary: 'Notiz · Gegner (optional)',
  shareSecondaryInvite: 'Prozess-Zeile hinterlassen (optional)',
  shareMoreSummary: 'Weitere Teilen-Optionen',
  lineDraftSummary: 'Akteur · Size',
  explainModeLabel: 'Erklären',
  explainModeAria: 'Erklärmodus — Lerntipps anzeigen',
  reviewScopeLabel: 'Review bis',
  reviewScopePreflop: 'Preflop',
  reviewScopeFlop: 'Flop',
  reviewScopeRiver: 'River',
  reviewScopeAria: 'Review-Umfang — spätere Streets einklappen (nicht löschen)',
  shareProcessHu: 'Heads-up',
  shareProcessMultiway: 'Multiway',
  shareReviewedLabel: 'Review',
  summaryCopyLabel: 'In Chat einfügen — lesbar + Pro',
  summaryProLabel: 'Pro-Notation',
  emptyDash: '—',
  copyBoth: 'Im Chat teilen',
  copyHuman: 'Lesbar',
  copyPro: 'Pro-Notation',
  copied: 'Kopiert ✓',
  copiedToast: 'Zusammenfassung kopiert',
  screenshotHint: 'Aufnahme = sauberer Kartenshot · Link = Hand erneut öffnen',
  captureMode: 'Aufnahme',
  captureExit: 'Aufnahme beenden',
  saveShareImage: 'Bild speichern',
  shareImage: 'Bild teilen',
  imageSaved: 'Gespeichert ✓',
  imageShared: 'Geteilt ✓',
  imageSavedToast: 'Bild gespeichert',
  imageSharedToast: 'Bild geteilt',
  imageFailedToast: 'Bild konnte nicht erstellt werden',
  shareText: 'Text teilen',
  shared: 'Geteilt ✓',
  copyLink: 'Link kopieren',
  linkCopiedToast: 'Hand-Link kopiert',
  linkWithoutKnownHolesToast: 'Link ohne Villain-Hole-Cards kopiert (zu lang damit)',
  linkTooLongToast: 'Hand zu groß für Share-Link',
  sharedToast: 'Geteilt',
  shareFailedToast: 'Teilen fehlgeschlagen',
  newHand: 'Neue Hand',
  receivedQuietRerecordCta: 'Eigenen Prozess aufzeichnen',
  draftRestoredHint: 'Entwurf wiederhergestellt — fortsetzen oder neu?',
  draftContinue: 'Fortsetzen',
  actorFoldedHint: 'Bereits gefoldet',
  summaryHeading: '[Holecard EX Hand-Zusammenfassung]',
  summaryPlayers: (n) => `Spieler: ${n}-max`,
  summaryBlinds: (b) => `Blinds: ${b}`,
  summaryHero: (p) => `Sitz: ${p}`,
  summaryStack: (s) => `Stack: ${s}`,
  summaryEff: (e) => `Eff-Stack: ${e} BB`,
  summaryPot: (p) => `Pot: ${p} BB`,
  summaryHoleLine: (h) => `Hole: ${h}`,
  summaryHolesHeader: 'Holes:',
  summaryKnownHoleLine: (label, cards) => `· ${label}: ${cards}`,
  summaryBoardLine: (b) => `Board: ${b}`,
  summaryActionsHeader: '── Aktionen ──',
  summaryFooter: '— Erstellt mit Holecard EX',
  summaryProHeader: '── Pro-Notation ──',
  tableLine: (n, blinds) => `${n}-max · ${blinds}`,
  errorBlinds: 'Ungültige Blinds. BB muss > 0 sein; SB ≥ 0 und ≤ BB.',
  hintFlopPartial: 'Flop hat meist 3 Karten',
  hintNoActions: 'Ohne Aktionen geht auch — „Eintrag beenden“ teilt den bisherigen Stand',
  missingFlopBoard: 'Flop-Aktionen vorhanden, aber Flop-Board fehlt',
  missingTurnBoard: 'Turn-Aktionen vorhanden, aber Turn-Karte fehlt',
  missingRiverBoard: 'River-Aktionen vorhanden, aber River-Karte fehlt',
  boardActionsMismatch: 'Aktionen auf einer Street ohne Board-Karten',
  boardNeedFlop: 'Flop-Board ist leer — Karten für klareren Review hinzufügen',
  boardNeedFlopPartial: 'Flop-Karten vervollständigen',
  boardNeedTurn: 'Turn-Karte ist leer — für klareren Review hinzufügen',
  boardNeedRiver: 'River-Karte ist leer — für klareren Review hinzufügen',

  softGateTitle: 'Einige Felder sind noch leer',
  softGateBody: 'Hole-Cards sind noch leer. Holes ergänzen, um den Prozess festzuhalten, oder trotzdem fortfahren.',
  softGateFix: "Hole-Cards hinzufügen",
  softGateForceConfirm: "Unvollständig wirklich teilen?",
  softGateMissingHoles: (seat) => `${seat}-Hole-Cards (2)`,
  softGateMissingActions: "Mindestens eine Aktion",
  softGateBodyLead: "Noch nötig:",
  incompleteBadge: "Unvollständig",
  softGateContinue: 'Trotzdem Zusammenfassung',
  softGateShare: 'Trotzdem teilen',
  softGateCopy: 'Trotzdem kopieren',
  softGateCancel: 'Zurück',
  pickerDisabled: 'Kein Slot gewählt',
  step: {
    setup: 'Tisch',
    position: 'Sitz',
    cards: 'Hand',
    board: 'Board',
    actions: 'Linie',
    summary: 'Teilen',
  },
  street: {
    preflop: 'Preflop',
    flop: 'Flop',
    turn: 'Turn',
    river: 'River',
  },
  actionType: {
    fold: 'Fold',
    check: 'Check',
    call: 'Call',
    bet: 'Bet',
    raise: 'Raise',
    allin: 'All-in',
  },
  suit: {
    s: 'Pik',
    h: 'Herz',
    d: 'Karo',
    c: 'Kreuz',
  },
  positionHintMap: {
    UTG: 'Under the Gun',
    "UTG+1": 'UTG+1',
    MP: 'Middle Position',
    "MP+1": 'MP+1',
    HJ: 'Hijack',
    CO: 'Cutoff',
    BTN: 'Button (Dealer)',
    SB: 'Small Blind',
    BB: 'Big Blind',
  },
  progressAria: (current, total, label) =>
    `Schritt ${current} von ${total}: ${label}`,
  adArea: 'Anzeigenplatz',
  adTop: 'Oberer Anzeigenplatz',
  adBottom: 'Unterer Anzeigenplatz',
  adPlaceholderHint: 'AdSense-ID fehlt — Platzhalter bis Deploy',
  // Softwise M10b: memory-order input
  endHere: "Hier beenden",
  finishRecord: "Eintrag beenden",
  reviewAnte: (v) => `Ante ${v}`,
  reviewEffStack: (v) => `eff. ${v}`,
  reviewBreakdownAria: 'Nach Straße',
  reviewPlayers: (n) => `${n} Spieler`,
  // vocab-tags:start — screen-only poker vocabulary (review breakdown)
  reviewVocab: {
    trips: 'Trips',
    paired: 'gepaart',
    monotone: 'monoton',
    twoTone: 'zweifarbig',
    rainbow: 'Rainbow',
    limp: 'Limp',
    open: 'Open',
    threeBet: '3-Bet',
    fourBet: '4-Bet',
    fiveBet: '5-Bet',
    squeeze: 'Squeeze',
    coldCall: 'Cold Call',
    checkRaise: 'Check-Raise',
    cBet: 'C-Bet',
    donkBet: 'Donk-Bet',
    probeBet: 'Probe-Bet',
  },
  shareSavedMark: 'Gespeichert',
  // vocab-tags:end
  flowAskFlop: "Flop · 3 Karten",
  flowAskTurn: "Turn · 1 Karte",
  flowAskRiver: "River · 1 Karte",
  flowWhoActs: "Am Zug",
  flowSizeCustom: "Eigene",
  flowSizeConfirm: "OK",
  flowSizeLabel: "Größe (bb)",
  flowDone: "Linie erfasst",
  flowRewind: "Ab hier neu",
  flowRewindCancel: "Abbrechen",
  flowSeatUnrecorded: "nicht erfasst",
  flowSeatNotInvolved: "nicht beteiligt",
  flowMemoryCut: "Ab hier nicht mehr erinnern",
  lineStripAria: "Bisher erfasste Linie",
  // Soft G: optional ending record (L1.5) — seat-subject, press-only, Quiet
  endingSummary: 'Ende (optional)',
  endingShownLabel: 'Beim Showdown gezeigte Karten',
  endingPotLabel: 'Pot',
  endingCardsInput: 'Karten',
  endingMuck: 'Nicht gezeigt (Muck)',
  endingUnknown: 'Unbekannt',
  endingPotTo: (seat) => `${seat} nimmt den Pot`,
  endingSplit: 'Geteilt',
  endingLineLabel: 'Ende',
  endingShownCards: (seat, cards) => `${seat} zeigt ${cards}`,
  endingShownMuck: (seat) => `${seat} nicht gezeigt (Muck)`,
  endingShownUnknown: (seat) => `${seat} Karten unbekannt`,
  endingPotSplit: 'Pot geteilt',
  endingPotUnknown: 'Pot unbekannt',
  linkWithoutEndingToast: 'Link zu lang – Ende wurde weggelassen',
  linkWithoutTakeawayToast: 'Link zu lang – Prozesszeile wurde weggelassen',
  endingShownAria: (seat) => `${seat} Showdown-Karten`,
}

export default de
